module.exports = __webpack_public_path__ + "img/check.eabaf5df.svg";